import { useEffect } from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';

import { Select } from '../../components/select/Select';
import { DescriptionHeader } from '../../features/user/components/description-header';
import { getCurrentMember } from '../../lib/utils/get-current-member';
import { toastPool } from '../../features/toasts/models/toast-pool';
import { Toast } from '../../features/toasts/models/toast';
import { catchError } from '../../core/catch-error';
import { uiStore } from '../../core/stores/ui-store';

import type { Member } from '../../app/entities';

const timeFormatOptions = [
  { value: '12h', label: '12-hour (2:30pm)' },
  { value: '24h', label: '24-hour (14:30)' },
];

export const PreferencesPage = observer(() => {
  const member = getCurrentMember();

  useEffect(() => {
    uiStore.pageTitle = {
      label: 'Preferences',
    };

    return () => {
      uiStore.pageTitle = {
        label: '',
      };
    };
  });

  const handleTimeFormatChange = async ({ target }: { target: { value: string } }) => {
    const timeFormat = target.value as '12h' | '24h';

    if (!member || timeFormat === member.preferences?.timeFormat) {
      return;
    }

    try {
      await member.update({
        preferences: {
          ...member.preferences,
          timeFormat,
        },
      } as Partial<Omit<Member, '_id'>>);
      toastPool.insert(new Toast('Your settings are updated successfully'));
    } catch (e) {
      catchError(e);
    }
  };

  return (
    <>
      <DescriptionHeader
        title="Preferences"
        description="Customize how times are displayed in your current workspace"
      />

      <FieldContainer>
        <Select
          name="timeFormat"
          value={member?.preferences?.timeFormat === '24h' ? '24h' : '12h'}
          onSelect={handleTimeFormatChange}
          options={timeFormatOptions}
          label="Time format"
          disabled={!member}
        />
      </FieldContainer>
    </>
  );
});

const FieldContainer = styled.div`
  margin-bottom: 2.4rem;
`;
